import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../ModalConversion';
import AccountsUsersService from '../../../services/AccountsUsersService';

const EMPTY = {
    companyName: '', address: '', rfc: '', regimenFiscal: '', usoCfdi: '',
};

export function BillingDataModal({ isOpen, onClose, account, onSaved }) {
    const [form, setForm] = useState(EMPTY);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen && account) {
            setError('');
            setLoading(true);
            AccountsUsersService.getBilling(account.prefix)
                .then((res) => {
                    const bd = res.billing_data || {};
                    setForm({
                        companyName: bd.companyName || '',
                        address: bd.address || '',
                        rfc: bd.rfc || '',
                        regimenFiscal: bd.regimenFiscal || '',
                        usoCfdi: bd.usoCfdi || '',
                    });
                })
                .catch((e) => setError(e.message))
                .finally(() => setLoading(false));
        }
    }, [isOpen, account]);

    const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSaving(true);
        try {
            await AccountsUsersService.setBillingData({
                prefix: account.prefix,
                companyName: form.companyName.trim(),
                address: form.address.trim(),
                rfc: form.rfc.trim(),
                regimenFiscal: form.regimenFiscal.trim(),
                usoCfdi: form.usoCfdi.trim(),
            });
            if (onSaved) onSaved('Datos de facturación guardados correctamente');
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <div className="p-4">
                <h4 className="text-white mb-1">Datos de facturación</h4>
                <div className="text-white-50 small mb-3">
                    {account ? `${account.pub_name} (${account.prefix})` : ''}
                </div>

                {loading ? (
                    <div className="text-center py-4 text-white-50"><FontAwesomeIcon icon={faSpinner} spin /> Cargando...</div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && <div className="alert alert-danger py-2">{error}</div>}
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label text-white-50">Razón social *</label>
                                <input type="text" className="form-control bg-dark text-white border-secondary py-2" value={form.companyName} onChange={(e) => set('companyName', e.target.value)} required />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-white-50">RFC *</label>
                                <input type="text" className="form-control bg-dark text-white border-secondary py-2" value={form.rfc} onChange={(e) => set('rfc', e.target.value)} required />
                            </div>
                            <div className="col-12">
                                <label className="form-label text-white-50">Domicilio</label>
                                <input type="text" className="form-control bg-dark text-white border-secondary py-2" value={form.address} onChange={(e) => set('address', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-white-50">Régimen fiscal</label>
                                <input type="text" className="form-control bg-dark text-white border-secondary py-2" value={form.regimenFiscal} onChange={(e) => set('regimenFiscal', e.target.value)} placeholder="Ej. 601" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-white-50">Uso CFDI</label>
                                <input type="text" className="form-control bg-dark text-white border-secondary py-2" value={form.usoCfdi} onChange={(e) => set('usoCfdi', e.target.value)} placeholder="Ej. G03" />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-4">
                            <button type="button" className="btn btn-outline-secondary px-4 rounded-pill" onClick={onClose} disabled={saving}>Cancelar</button>
                            <button type="submit" className="btn btn-success px-4 rounded-pill" disabled={saving}>
                                {saving && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                                Guardar datos de facturación
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </Modal>
    );
}

export default BillingDataModal;